import React from 'react'
import { Grid, Typography, Box, List, ListItem, Paper, Divider } from '@mui/material'
import _ from "lodash"
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"
import { useDispatch, useSelector } from 'react-redux'
import { Download, PictureAsPdf } from '@mui/icons-material'

const TrackerDialog = (props) => {
    const Article = props.Article
    const { user: currentUser } = useSelector((state) => state.auth);
    const dispatch = useDispatch()

    // const handleChange = (event, newValue) => {
    //     setValue(newValue);
    //     setIsFlipped(-1)
    //     setCurrentTab(props.cards.KeyAreas.KeyAreaArray[newValue])
    // };

    const motionVariants = {
        hidden: { opacity: 0, x: 0, y: 0 },
        show: {
            opacity: 1, x: 0, y: 0,
            transition: {
                delay: 0.1,
                duration: 0.5,
            }
        }
    }


    return (
        <Paper elevation={1} style={{ marginTop: '150px', padding: '40px' }}>
            <Grid container direction="row" alignItems="top" justifyContent="center" spacing={2}>
                <Grid item xs={12}>


                    <Grid container direction="row" alignItems="top" justifyContent="center" spacing={2}>

                        <Grid item xs={12} md={12}>
                            <Grid container direction="row" alignItems="top" justifyContent="center" spacing={2}>

                                <Grid item xs={12} m={1}>
                                    <Divider orientation='horizontal' sx={{ borderColor: "rgba(0,0,0,0.1)", borderRadius: '90%', borderBottomWidth: 2, m: 1 }} />
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Typography variant="h4" align="center">{Article.ComponentValues.TitleBlock.Title}</Typography>
                                </Grid>
                                <Grid item xs={12} m={1}>
                                    <Divider orientation='horizontal' sx={{ borderColor: "rgba(0,0,0,0.1)", borderRadius: '90%', borderBottomWidth: 2, m: 1 }} />
                                </Grid>

                                <Grid item xs={12} md={12}>

                                    <Typography ml={1} variant="body1" dangerouslySetInnerHTML={{ __html: _.unescape(Article.ComponentValues.Abstract) }}></Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container direction="row" alignContent="center" justifyContent="center" spacing={2}>
                                        <Grid item xs={6}>
                                            <Box >

                                                <a href={"../../WsWebAppWellSuite/media/" + Article.ComponentValues.MediaPath}
                                                    target="_blank"
                                                >
                                                    <Typography variant="body1" align="center"><Download size="large" />Download Now!</Typography>
                                                </a>
                                            </Box>
                                        </Grid>

                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Divider orientation='horizontal' sx={{ borderColor: "rgba(0,0,0,0.1)", borderRadius: '90%', borderBottomWidth: 2, m: 1 }} />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <Typography ml={1} variant="caption" dangerouslySetInnerHTML={{ __html: _.unescape(Article.ComponentValues.References.replace(/(?:\r\n|\r|\n)/g, "")) }}></Typography>
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <Divider orientation='horizontal' sx={{ borderColor: "rgba(0,0,0,0.1)", borderRadius: '90%', borderBottomWidth: 2, m: 1 }} />
                    </Grid>
                </Grid>
            </Grid>
        </Paper>




    )

}


export default TrackerDialog;